import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';

import { AuthCard } from '../../components/AuthCard';
import { Form } from '../../components/Form';
import { Label, TextInput } from '../../components/Input';
import { Button } from '../../components/Button';
import { Link } from '../../components/Link';

import { api } from '../../utils/api';
import { showMessage } from '../../actions/message';

export const ResetPassword: React.FC = () => {
  const dispatch = useDispatch();
  const [fetching, setFetching] = useState(false);
  const { handleSubmit, register } = useForm();

  const onSubmit = useCallback(
    async (values) => {
      try {
        setFetching(true);

        await api.post(
          '/login/email_reset_password',
          {},
          {
            email: values.email,
          }
        );

        dispatch(
          showMessage({
            message: 'Controlla la tua mail per completare la registrazione!',
          })
        );
      } catch {
        dispatch(
          showMessage({
            message: 'Si è verificato un errore durante la tua richiesta',
            type: 'danger',
          })
        );
      } finally {
        setFetching(false);
      }
    },
    [dispatch]
  );

  return (
    <AuthCard>
      <Form onSubmit={handleSubmit(onSubmit)} centered>
        <Label>E-mail</Label>
        <TextInput
          label={'E-mail'}
          type={'email'}
          {...register('email', { required: true })}
        />

        <Button loading={fetching} type={'submit'}>
          Manda e-mail di conferma
        </Button>

        <Link to={'/'}>Sei già registrato? Clicca qui per entrare</Link>
      </Form>
    </AuthCard>
  );
};
